function injectStyle (context) {
  require("!!../../../../../node_modules/_extract-text-webpack-plugin@3.0.2@extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../node_modules/_vue-loader@14.2.4@vue-loader/lib/style-compiler/index?{\"optionsId\":\"0\",\"vue\":true,\"id\":\"data-v-d2148bb4\",\"scoped\":true,\"sourceMap\":false}!sass-loader?{\"sourceMap\":true}!sass-resources-loader?{\"resources\":[\"/drone/src/src/style/variables.scss\",\"/drone/src/src/site/assets/styles/_tokens.scss\"]}!../../../../../node_modules/_vue-loader@14.2.4@vue-loader/lib/selector?type=styles&index=0!./roleAuth.vue")
}
/* script */
export * from "!!ts-loader!../../../../../node_modules/_vue-loader@14.2.4@vue-loader/lib/selector?type=script&index=0!./roleAuth.vue"
import __vue_script__ from "!!ts-loader!../../../../../node_modules/_vue-loader@14.2.4@vue-loader/lib/selector?type=script&index=0!./roleAuth.vue"
/* template */
import {render as __vue_render__, staticRenderFns as __vue_static_render_fns__} from "!!../../../../../node_modules/_vue-loader@14.2.4@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-d2148bb4\",\"hasScoped\":true,\"optionsId\":\"0\",\"buble\":{\"transforms\":{}}}!../../../../../node_modules/_vue-loader@14.2.4@vue-loader/lib/selector?type=template&index=0!./roleAuth.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d2148bb4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
import normalizeComponent from "!../../../../../node_modules/_vue-loader@14.2.4@vue-loader/lib/runtime/component-normalizer"
var Component = normalizeComponent(
  __vue_script__,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/padViews/staff/components/roleAuth.vue
// module id = null
// module chunks = 